module.exports = __webpack_public_path__ + "static/media/meteor.783ff388.svg";